import { Box, useTheme } from '@mui/material';
import { tokens } from '../theme/theme';

const ResponsiveBox = ({ children, customMaxHeight }) => {
    const theme = useTheme();
        const colors = tokens(theme.palette.mode);
    return (
        <Box
            sx={{
                padding: '5px',
                borderRadius: '10px',
                maxHeight: customMaxHeight || {
                    xs: '72vh', // Extra small devices (phones)
                    sm: '72vh', // Small devices (tablets)
                    md: '74vh', // Medium devices (small laptops)
                    lg: '74vh', // Large devices (desktops)
                    xl: '82vh', // Extra large devices (large desktops)
                },
                overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                '&::-webkit-scrollbar': {
                    width: '8px',
                },
                '&::-webkit-scrollbar-track': {
                    background: colors.primary[400],
                    borderRadius: '10px',
                },
                '&::-webkit-scrollbar-thumb': {
                    background: colors.blueAccent[600],
                    borderRadius: '10px',
                    '&:hover': {
                        background: colors.blueAccent[800],
                    },
                },
                '&::-webkit-scrollbar-corner': {
                    background: colors.primary[700],
                }
            }}
        >
            {children}
        </Box>
    );
};

export default ResponsiveBox;
